import req from './http.js'
import { apiAuth } from './fetch.js'

// 新增產品缺貨通知
export const apiRegisterProduct = (org_id, params) => req('post', '/notify/register/product?org=' + org_id, params)

// 新增要通知的平台 ex.line
export const apiRegisterGroup = (org_id, params) => req('post', '/notify/register/group?org=' + org_id, params)

// 更新要通知的channel
export const apiPatchRegisterGroup = (org_id, params) => req('post', '/notify/register/group?org=' + org_id, params)

// 更新要被通知的產品狀態
export const apiPatchRegisterProductEnable = (org_id, params) => req('patch', '/notify/register/product/enable?org=' + org_id, params)

// 取得全部商品
export const apiGetProducts = (org_id, channel_id) => req('get', '/notify/products?org=' + org_id + '&channel_id=' + channel_id)

// 取得sales_channel_id
export const apiGetChannel = (org_id) => req('get', '/notify/channel?org=' + org_id)

// 刪除sales_channel_id
export const apiDeleteChannel = (org_id, channel_id) => req('delete', '/notify/channel?org=' + org_id + '&channel_id=' + channel_id)

// 取得缺貨通知
export const apiGetNotify = (org_id) => req('get', '/notify/notify?org=' + org_id)

// 綁定line Notify Token給container
export const apiCreateLineNotify = (org_id, params) => req('post', `/notify/line/setting?org=${org_id}`, params).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 測試通知
export const apiTestNotifyToken
= (org_id, container_id) => req(
    'get', `/notify/line/test?container_id=${container_id}&test=true&org=${org_id}`,
    null
)
.then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetContainerNotify = (org_id, container_id, vid, is_read, page, limit, type) => req(
    'get', `/notify/container?container_id=${container_id}&is_read=${is_read}&page=${page}&limit=${limit}&org=${org_id}&view_id=${vid}&type=${type}`, 
    null
)
.then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetNotifyData = (org_id, id) => req(
    'get', `/notify/container/by?id=${id}&org=${org_id}`, 
    null
)
.then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiReadNotify = (org_id, id) => req(
    'post', `/notify/container/read?id=${id}&org=${org_id}`, null
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetContainerNotifyV2  = async (params) => {
    const data = {
        container_id: params.container_id,
        org: params.org || null,
        page: params.page || null,
        limit: params.limit || null,
        is_read: params.is_read !== null && params.is_read !== undefined ? params.is_read : null,

        view_id: params.view_id || null,
        type: params.type !== null && params.type !== undefined ?  params.type : null,
    }
    const url = '/notify/container'
    return (await apiAuth('GET', url, data, 'default')).data
}
export const apiGetNotifyInfo = async (params) => {
  const res = (await apiAuth('GET', '/notify/list', params)).data
  if (res.code === 200) {
    return res.data
  }

  throw new Error('取得資料失敗')
}

export const apiCreateOrUpdateNotifyGroup = async (params, payload) => {
  await apiAuth('POST', '/notify/register/linebot', { params, payload })
}

export const apiBindLineBotBath = async (params, payload) => {
    try {
        const res = await apiAuth('POST', '/notify/register/linebot/batch', { params, payload })
        if (res.status === 200) {
            res.data.payload = payload
            res.data.params = params
            return res.data
        }
        throw new Error('綁定失敗')
    } catch (error) {
        return Promise.reject({
            message: error.message,
            payload: payload,
            params
        })
    }
}

export const apiUnbindNotifyGroup = async (params) => {
  await apiAuth('DELETE', '/notify/notify', params)
}